import { Action, State, StateContext, Store } from '@ngxs/store';
import { Injectable } from '@angular/core';
import { NgxsStateFacade } from '../../shared/store/ngxs-state-facade';

export interface ContactStateModel {
  contactForm: {
    model: {
      question: string;
    };
    dirty: boolean;
    status: string;
    errors: { [key: string]: unknown };
  };
}

export class Reset {
  static readonly type = '[Contact] Reset';
}

const defaults: ContactStateModel = {
  contactForm: {
    model: {
      question: '',
    },
    dirty: false,
    status: '',
    errors: {},
  },
};

@State<ContactStateModel>({
  name: 'contact',
  defaults: defaults,
})
@Injectable()
export class ContactState extends NgxsStateFacade<ContactStateModel> {
  constructor(store: Store) {
    super(store, 'contact');
  }

  reset(): void {
    this.store.dispatch(new Reset());
  }

  @Action(Reset)
  resetHandler(ctx: StateContext<ContactStateModel>) {
    ctx.setState(defaults);
  }
}
